<template>
    <button
        v-tooltip="tooltip"
        type="button"
        role="switch"
        :aria-checked="String(value)"
        :aria-label="label"
        class="relative h-5 w-9 shrink-0 cursor-pointer rounded-full border-none p-0 transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-theme-accent focus-visible:ring-offset-2"
        :class="value ? 'bg-theme-accent' : 'bg-theme-switch-track'"
        @click="$emit('toggle', !value)"
    >
        <span
            class="absolute left-0.5 top-0.5 h-4 w-4 rounded-full bg-theme-bg shadow transition-transform duration-200"
            :class="{ 'translate-x-4': value }"
        ></span>
    </button>
</template>

<script>
export default {
    name: 'BaseToggleSwitch',

    props: {
        /**
         * Current on/off state of the switch.
         */
        value: {
            type: Boolean,
            required: true,
        },
        /**
         * Accessible name announced by screen readers.
         */
        label: {
            type: String,
            required: true,
        },
        /**
         * Optional tooltip describing what the switch controls.
         */
        tooltip: {
            type: String,
            default: null,
        },
    },

    emits: ['toggle'],
};
</script>
